import * as request from 'superagent';
import MarkdownIt from 'markdown-it';

var md = new MarkdownIt({ html: true });

const regex = /\@embedly\[(http.*?)\]/g;
const apiKey = '8ffe1b10b43c4939adc17a15f6e4949b';

export default function processLinks(markdown) {
    var links = {},
        urls,
        match,
        html;

    while ((match = regex.exec(markdown)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (match.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        let [source, url] = match;

        if (!links[url]) {
            links[url] = {
                sources: []
            };
        }

        links[url].sources.push(source);
    }

    urls = Object.keys(links);

    if (markdown != null) {
        html = md.render(markdown);
    }
    else {
        html = null;
    }

    if (!urls || !urls.length) {
        return new Promise(resolve => {
            resolve(html);
        });
    }

    return request
        .get('https://api.embedly.com/1/oembed')
        .query({ urls: urls, key: apiKey })
        .then(res => {
            res.body.forEach((detail, index) => {
                links[urls[index]].html = `<a class="embedly-card" data-card-key="${apiKey}" data-card-theme="light" data-card-controls="0" href="${urls[index]}">${detail.title}</a>`;
            });

            for (var link in links) {
                links[link].sources.forEach(source => {
                    html = html.replace(source, links[link].html);
                });
            }

            return html;

            // TODO: handle errors
            // http://docs.embed.ly/docs/oembed
        }, error => {
            console.error('Error during embedly transform: ' + JSON.stringify(error));
            return html;
        });
}


// WEBPACK FOOTER //
// ./src/app/utils/embedly.js